import React, { useEffect, useRef } from 'react';
import { usePodcastStore } from '../../stores/podcastStore'; // Corrected path
import { getOfflinePodcast } from '../../utils/offlineStorage'; // 🟢 Importamos utilidad offline

const PodcastAudioEngine = () => {
  const audioRef = useRef(new Audio());
  const currentPodcast = usePodcastStore((state) => state.currentPodcast);
  const isPlaying = usePodcastStore((state) => state.isPlaying);
  const isLocked = usePodcastStore((state) => state.isLocked);
  const volume = usePodcastStore((state) => state.volume);
  const streamToken = usePodcastStore((state) => state.streamToken); // 🟢 1. Obtenemos el token de acceso
  const saveProgress = usePodcastStore((state) => state.saveProgress);
  const progress = usePodcastStore((state) => state.progress);
  const playNext = usePodcastStore((state) => state.playNext);
  const setDuration = usePodcastStore((state) => state.setDuration);
  const setCurrentTime = usePodcastStore((state) => state.setCurrentTime);

  // 1. Manejo de cambio de fuente (Source)
  useEffect(() => {
    const audio = audioRef.current;

    if (currentPodcast && !isLocked) {
      // Solo cargamos si no hay bloqueo
      // 🟢 2. Construimos la URL final, añadiendo el token si existe
      const finalAudioUrl = currentPodcast.isPremium && streamToken 
        ? `${currentPodcast.audioUrl}?token=${streamToken}` 
        : currentPodcast.audioUrl;

      if (audio.src !== finalAudioUrl) {
        audio.src = finalAudioUrl;
        // Restaurar punto donde lo dejó
        audio.currentTime = progress[currentPodcast._id] || 0;
        
        if (isPlaying) {
            audio.play().catch(e => console.error("Error playback:", e));
        }
      }
    } else if (isLocked) {
        audio.pause(); // Detener si se bloquea
    }
  }, [currentPodcast?._id, isLocked, streamToken]); // 🟢 3. Añadimos el token a las dependencias

  // 2. Sincronización de Estado Play/Pause/Volumen
  useEffect(() => {
    const audio = audioRef.current;
    if (currentPodcast && !isLocked) {
        isPlaying ? audio.play().catch(() => {}) : audio.pause();
    }
    audio.volume = volume;
  }, [isPlaying, volume, isLocked, currentPodcast]);

  // 3. Listeners de Eventos de Audio
  useEffect(() => {
    const audio = audioRef.current;

    const handleTimeUpdate = () => {
      if (currentPodcast && !isLocked) {
        saveProgress(currentPodcast._id, audio.currentTime);
      }
    };

    const handleLoadedMetadata = () => setDuration(audio.duration);
    const handleEnded = () => playNext();

    audio.addEventListener('timeupdate', handleTimeUpdate);
    audio.addEventListener('loadedmetadata', handleLoadedMetadata);
    audio.addEventListener('ended', handleEnded);

    return () => {
      audio.removeEventListener('timeupdate', handleTimeUpdate);
      audio.removeEventListener('loadedmetadata', handleLoadedMetadata);
      audio.removeEventListener('ended', handleEnded);
    };
  }, [currentPodcast, isLocked, saveProgress, playNext, setDuration]);

  return null; // Componente lógico puro
};

export default PodcastAudioEngine;